import React from "react";
import styles from "./ExploreAssets.module.scss";
export default function ExploreAssets() {
  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
      <div className={styles.inputContainer}>
        <img className={styles.leftIcon} src={"/assets/search.svg"} />
          <input
            type="text"
            name="search"
            className={styles.input}
            placeholder="Search"
            onChange={()=>console.log("changed")}
          />
      </div>
        {Array.from(Array(6), (e, i) => {
          return (
            <div className={styles.tableWrapper} key={i}>
              <div className={styles.assetBasics}>
                <img
                  src={"/assets/whiteDots.svg"}
                  width="10px"
                  height="14px"
                  alt="Picture of the author"
                />
                <div className={styles.flexcolumn}>
                  <img
                    src={"/assets/bitcoin-btc-logo.svg"}
                    width="25px"
                    height="25px"
                    alt="Picture of the author"
                  />
                  <div className={styles.coinName}>Bitcoin</div>
                  <div className={styles.coinSymble}>BTC</div>
                </div>
                <div className={styles.seprator}></div>
              </div>
              <div className={styles.flexCol}>
                <div className={styles.price}>$7,296.46</div>
                <div className={styles.profit}>+0.59</div>
              </div>
              <img
                  src={"/assets/add.svg"}
                  width="15px"
                  height="15px"
                  alt="Picture of the author"
                />
            </div>
          );
        })}
      </div>
    </div>
  );
}

